import { getProgramVersion } from '../sync/program-version.js';

/** Presigned query strings change every API call — fingerprint pathname only. */
function stableMediaKey(url) {
  if (!url) return '';
  try {
    return new URL(url).pathname;
  } catch {
    return url.split('?')[0] ?? url;
  }
}

/** @param {object | null | undefined} program */
export function programFingerprint(program) {
  if (!program) return '';
  const version = getProgramVersion(program);
  const playlistId = program.playlistId ?? program.playlist?.id ?? '';
  const slots = program.slots ?? [];
  const slotsKey = slots
    .map(
      (s) =>
        `${s.id}|${s.position}|${s.durationSec}|${s.kind}|${stableMediaKey(s.mediaUrl)}|${s.templateId ?? ''}`,
    )
    .join(';');
  return `${playlistId}@${version}#${slotsKey}`;
}
